<template>
  <div id="center-base" class="flex">
    <div
      id="center-tabs"
      class="sticky top-18 left-0 z-40 w-80 flex-shrink-0 bg-pure-white border-r border-slate-400 overflow-y-auto"
      :style="{ height: 'calc(100vh - 4.5rem - 0.5rem)' }"
    >
      <div
        class="sticky top-0 z-10 h-24 px-6 flex items-center bg-pure-white border-b border-slate-400"
      >
        <BlTextTitle3 text="Center Settings" />
      </div>
      <div class="flex flex-col gap-1 px-3 py-1">
        <div v-for="(tab, idx) in tabs" :key="idx">
          <div v-if="tab.divider" class="h-0.5 w-full bg-slate-300"></div>
          <router-link
            v-else
            :to="tab.target"
            class="relative h-12 px-3 flex items-center rounded transition-all duration-300"
            :class="[tab.isActive ? 'bg-slate-300' : 'hover:bg-hover-state']"
          >
            <BlTextSubtitle3 :text="tab.label" />
          </router-link>
        </div>
      </div>
    </div>

    <div
      id="center-body"
      class="flex flex-col flex-grow"
      :class="{
        'bg-slate-100':
          $route.params.tab && $route.params.tab.includes('package')
      }"
    >
      <GeneralInformation v-if="!$route.params.tab" />
      <CenterClientAcquisition
        v-if="$route.params.tab === 'client-acquisition'"
      />
      <CenterPackageItems v-if="$route.params.tab === 'package-item'" />
      <CenterPackages v-if="$route.params.tab === 'package'" />
      <CenterReasonSetting v-if="$route.params.tab === 'reason-setting'" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import GeneralInformation from "./GeneralInformation.vue";
import CenterClientAcquisition from "./CenterClientAcquisition.vue";
import CenterPackageItems from "./CenterPackageItems.vue";
import CenterPackages from "./CenterPackages.vue";
import CenterReasonSetting from "./CenterReasonSetting.vue";

import BlTextSubtitle3 from "../BlTextSubtitle3.vue";
import BlTextBody1 from "../BlTextBody1.vue";
import BlIcon from "../BlIcon.vue";
import BlTextTitle3 from "../BlTextTitle3.vue";

export default {
  name: "Center",
  components: {
    GeneralInformation,
    CenterClientAcquisition,
    CenterPackageItems,
    CenterPackages,
    CenterReasonSetting,
    //
    BlTextTitle3,
    BlTextSubtitle3,
    BlTextBody1,
    BlIcon
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    enableAppointment() {
      return this.currentCenter.enable_appointment;
    },
    enableSalesPipeline() {
      return this.currentCenter.enable_sales_pipeline;
    },
    tabs() {
      const salesPipeline = [
        {
          target: "/center/client-acquisition",
          isActive: this.$route.params.tab === "client-acquisition",
          label: "Client Acquisition Board"
        }
      ];
      const appointment = [
        {
          target: "/center/package-item",
          isActive: this.$route.params.tab === "package-item",
          label: "Package Items"
        },
        {
          target: "/center/package",
          isActive: this.$route.params.tab === "package",
          label: "Packages"
        },
        {
          target: "/center/reason-setting",
          isActive: this.$route.params.tab === "reason-setting",
          label: "Cancellation & Rescheduling Reasons"
        }
      ];
      return [
        {
          target: "/center",
          isActive: !this.$route.params.tab,
          label: "General Information"
        },
        ...(this.enableSalesPipeline ? salesPipeline : []),
        { divider: true },
        ...(this.enableAppointment ? appointment : [])
      ];
    }
  },
  mounted() {
    if (!this.currentUser.role.includes("admin")) {
      return this.$router.push({ name: "Clients" });
    }
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) app.scroll({ top: 0, left: 0 });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/center/Center.vue